import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-d18c8df6"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_2 = { class: "copyright" }


export default /*#__PURE__*/_defineComponent({
  __name: 'AppFooter',
  setup(__props) {

const d = new Date();
const currentYear = d.getFullYear(); 

return (_ctx: any,_cache: any) => {
  const _component_q_avatar = _resolveComponent("q-avatar")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_toolbar_title = _resolveComponent("q-toolbar-title")!
  const _component_q_toolbar = _resolveComponent("q-toolbar")!
  const _component_q_footer = _resolveComponent("q-footer")!

  return (_openBlock(), _createBlock(_component_q_footer, {
    class: "footer",
    dark: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_toolbar, { class: "bg-dark flex-center flex" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_toolbar_title, null, {
            default: _withCtx(() => [
              _createVNode(_component_q_btn, {
                type: "a",
                flat: "",
                href: "https://prjctphoenix.xyz",
                target: "_blank"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_avatar, null, {
                    default: _withCtx(() => [
                      _hoisted_1
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("small", null, "© Copyright " + _toDisplayString(_unref(currentYear)) + ", Prjct Phoenix. All rights reserved.", 1)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})